import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import { debounce } from 'lodash';

@Component
export class PredictiveSearch extends ThemeComponent {
    @Ref() searchInput!: HTMLInputElement;
    @Ref() searchResults!: HTMLDivElement;

    @Prop({ default: null }) searchType!: string;

    scrollListener: (() => void)|null = null;

    init() {
        this.searchInput.addEventListener('input',
            debounce(() => {
                this.onChange();
            }, 300)
        );
    }

    onChange() {
        const searchTerm: string = this.searchInput.value.trim();

        if (!searchTerm.length) {
            this.clearResults();
            this.closeResults();
            return;
        }

        if (this.searchType == 'article') {
            this.getArticleResults(searchTerm);
        } else {
            this.getResults(searchTerm);
        }
    }

    appendResults(text: string): void {
        const format: Document = new DOMParser().parseFromString(text, 'text/html');
        const resultsMarkup: string | undefined =
            format.querySelector('#shopify-section-predictive-search')?.innerHTML || undefined;

        if (resultsMarkup === undefined) {
            return;
        }

        this.searchResults.innerHTML = resultsMarkup;
    }

    clearResults(): void {
        const results: HTMLDivElement | null = document.querySelector('#predictive-search-results') || null;

        if (results) {
            results.remove();
        }
    }

    openResults(): void {
        this.setAttribute('open', 'true');
        this.toggleScrollEvent(); // add scroll event
    }

    closeResults(): void {
        this.setAttribute('open', 'false');
        this.toggleScrollEvent(); // remove scroll event
    }

    scrollOccured() {
        this.searchInput.value = "";
        this.clearResults();
        this.closeResults();
    }

    getResults(searchTerm: string): void {
        const url: string =
            // eslint-disable-next-line max-len
            `/search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection&resources[limit]=3&section_id=predictive-search`;

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`${response.status}`);
                }
                return response.text();
            })
            .then((text) => {
                this.appendResults(text);
                this.openResults();
            })
            .catch((error) => {
                throw error;
            });
    }

    getArticleResults(searchTerm: string): void {
        const url: string =
        // eslint-disable-next-line max-len
        `/search/suggest?q=${searchTerm}&resources[type]=article&resources[limit]=10&section_id=predictive-search`;

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`${response.status}`);
                }
                return response.text();
            })
            .then((text) => {
                this.appendResults(text);
                this.openResults();
            })
            .catch((error) => {
                throw error;
            });
    }

    toggleScrollEvent() {
        if (!this.scrollListener) {
            this.scrollListener = () => this.scrollOccured();
            window.addEventListener('scroll', this.scrollListener);
        } else {
            window.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = null;
        }
    }
}
